import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./en/translation.json"
import fr from "./fr/translation.json";
import hi from "./hi/translation.json";
import de from "./de/translation.json";
{console.log("i18")}
i18n
  .use(LanguageDetector) // detects browser language
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      hi: { translation: hi },
      de: { translation: de }
    },
    fallbackLng: "en", // default
    interpolation: { escapeValue: false }
  });

export default i18n;
